// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"d3033463","342":"90915cbd","347":"c217acbf","368":"ca1e5224","453":"03346f77","553":"6e6d8b21","693":"a66bf10d","806":"9c842502"}[chunkId] + ".chunk.js";
};